<template>
	<div class="expert-score">
		<div class="container-fluid">
			<div class="wrapper" style="max-width:90%">
				<div class="content-page">
					<div class="content">
						<div class="row mb-1">
							<div class="col-xl-6">拟结题</div>
							<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="mb-2">
									<el-form ref="form" :model="query" label-width="110px">
										<el-row :gutter="10">
											<el-col :span="5">
												<el-form-item label="课题名称:"><el-input v-model="query.name"></el-input></el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="课题级别类别:">
													<!-- <el-cascader
														class="mr-2 mb-1"
														:options="subjectTypeOptions"
														:props="{ expandTrigger: 'hover', checkStrictly: true, label: 'name', value: 'id' }"
														placeholder="-课题类别-"
														clearable
														filterable
														@change="cascaderSubjectTypeChange"
													>
														<template slot-scope="{ node, data }">
															<span>{{ data.name }}</span>
															<span v-if="!node.isLeaf">({{ data.children.length }})</span>
														</template>
													</el-cascader> -->
													<el-select v-model="query.projectLevelId" clearable placeholder="请选择">
														<el-option
															v-for="item in subjectTypeOptions"
															:key="item.id"
															:label="item.name"
															:value="item.id">
														</el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="负责人:"><el-input v-model="query.userName"></el-input></el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="单位:"><el-input v-model="query.unitName"></el-input></el-form-item>
											</el-col>
										</el-row>
										<el-row :gutter="10">
											<el-col :span="5">
												<el-form-item label="立项年度:"><el-date-picker v-model="query.year" type="year" value-format="yyyy" placeholder="选择年"></el-date-picker></el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="初评结果:">
													<el-select v-model="query.internResults" clearable placeholder="请选择">
														<el-option
															v-for="item in reviewResultOptions"
															:key="item.id"
															:label="item.name"
															:value="item.name">
														</el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="复评结果:">
													<el-select v-model="query.reviewResults" clearable placeholder="请选择">
														<el-option
															v-for="item in reviewResultOptions"
															:key="item.id"
															:label="item.name"
															:value="item.name">
														</el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="5">
												<el-form-item label="终评结果:">
													<el-select v-model="query.finalResults" clearable placeholder="请选择">
														<el-option
															v-for="item in reviewResultOptions"
															:key="item.id"
															:label="item.name"
															:value="item.name">
														</el-option>
													</el-select>
												</el-form-item>
											</el-col>
											<el-col :span="4">
												<el-button type="primary" @click="searchData">查询</el-button>
												<el-button type="success" @click="exportExcel">导出Excel</el-button>
											</el-col>
										</el-row>
									</el-form>
								</div>
								<el-table
									id="table"
									:header-cell-style="tableHeaderStyle"
									ref="multipleTable"
									:data="list"
									tooltip-effect="dark"
									style="width: 100%"
									border
									@selection-change="handleSelectionChange"
								>
									<el-table-column type="selection" :selectable="isDisabled" width="55"></el-table-column>
									<el-table-column prop="projectManagementName" label="课题名称" min-width="150"></el-table-column>
									<el-table-column prop="year" label="立项年度" min-width="60"></el-table-column>
									<el-table-column prop="projectLevelName" label="课题级别"  min-width="60"></el-table-column>
									<el-table-column prop="projectTypeName" label="课题类别"  min-width="60"></el-table-column>
									<el-table-column prop="unitName" label="所属单位"  width="80"></el-table-column>
									<el-table-column prop="oneEmceeName" label="负责人"  width="80"></el-table-column>
									<el-table-column prop="internAvgScore" label="初评分" sortable width="60"></el-table-column>
									<el-table-column prop="internResults" label="初评结果" sortable width="80"></el-table-column>
									<el-table-column prop="reviewAvgScore" label="中评评分" sortable width="60"></el-table-column>
									<el-table-column prop="reviewResults" label="中评结果" sortable width="80"></el-table-column>
									<el-table-column prop="finalAvgScore" label="终评分" sortable min-width="60"></el-table-column>
									<el-table-column prop="finalResults" label="终评结果" sortable min-width="100"></el-table-column>
								</el-table>
								<div class="mt-2">
									<el-button class="mr-1" type="primary" @click="toUpdate(1)">批准结题</el-button>
									<el-button class="mr-1" type="warning" @click="toUpdate(0)">不予结题</el-button>
									<el-button class="mr-1" type="warning" @click="toUpdate(2)">退回修改</el-button>
								</div>
								<!-- 分页器 -->
								<div class="text-right mt-2">
									<el-pagination
										layout="total, sizes, prev, pager, next, jumper"
										background
										:current-page="query.pageNumber"
										:page-sizes="[10, 50, 100, 200]"
										:page-size="query.pageSize"
										:total="total"
										@size-change="handleSizeChange"
										@current-change="handlePageChange"
									></el-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
import { getAreaTree, getPlatformInformationData } from '@/api/after/systemManagement';
// import { getprojectDeclareQuasiList, auditProject } from '@/api/after/proposedProject';
import { getProposedClosingList, concludingFunction } from '@/api/after/topicManage.js'

import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
	name: 'proposedProject',
	components: {
		Breadcrumb
	},
	data() {
		return {
			tableHeaderStyle: {
				backgroundColor: '#3083c5',
				color: '#fff',
				textAlign:'center'
			},
			tableSort: {
				prop: 'projectTypeName',
				prop: 'learningTypeName',
				prop: 'disciplineName',
				prop: 'unitName',
				prop: 'oneEmceeName',
				prop: 'internNumber',
				prop: 'internResults'
			},
			// areaOptions: [], //区域列表
			subjectTypeOptions: [], //课题类别
			reviewResultOptions:[],
			//学段列表
			stageOptions: [
				{ id: '0', name: '幼儿园' },
				{ id: '1', name: '小学' },
				{ id: '2', name: '初中' },
				{ id: '3', name: '高中' },
				{ id: '4', name: '中/高职' },
				{ id: '5', name: '其他' }
			],
			// 立项状态
			projectStateOptions: [{ value: 0, label: '不予立项' }, { value: 1, label: '已立项' }],
			query: {
				finalResults:'',//终评结果			
				internResults:'',//初评结果			
				name:'',//课题名称			
				pageNumber:1,//页码,默认为1,示例值(1)			
				pageSize:10,//页大小,默认为10,示例值(10)			
				reviewResults:'',//复评结果			
				projectLevelId:'',//课题级别id			
				unitName:'',//单位			
				userName:'',//负责人名称			
				year:'',//立项年度
			},
			list: [],
			total: 0,
			multipleSelection: [], //被选中的项
			queryUpdate: { ids: [], type: 1 }
		};
	},
	mounted() {
		this.getReviewResult()
		
		this.getData();
		this.getPlatformInformationData();
	},
	methods: {
		// 获取数据列表
		getData(isNum) {
			if (isNum) this.query.pageNumber = 1;
			getProposedClosingList(this.query).then(res => {
				if (res.code == 200) {
					console.log('拟结题',res);
					this.list = res.data.records;
					this.total = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 获取区域树
		// getAreaTree() {
		//   getAreaTree().then((res) => {
		//     if (res.code == 200) {
		//       this.areaOptions = res.data;
		//     } else {
		//       this.$message.error(res.data);
		//     }
		//   });
		// },
		// 获取课题类别
		getPlatformInformationData() {
			getPlatformInformationData(1).then(res => {
				if (res.code == 200) {
					this.subjectTypeOptions = res.data;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 搜索
		searchData() {
			this.getData(true);
		},
		//区域筛选
		cascaderChange(e) {
			let num = null;
			e.length <= 0 ? (num = null) : (num = e[e.length - 1]);
			this.query.regionId = num;
		},
		//课题类别筛选
		// cascaderSubjectTypeChange(e) {
		// 	let num = null;
		// 	e.length <= 0 ? (num = null) : (num = e[e.length - 1]);
		// 	this.query.projectTypeId = num;
		// },
		// 配置表格禁止选中项
		isDisabled(row) {
			if (row.projectState === 1 || row.projectState === 0) {
				return false;
			}
			return true;
		},
		// 选择需要操作的项
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 批准结题/不予结题/退回修改
		// type	结题状态(0:不予结题,1:批准结题,2:退回修改)
		toUpdate(type) {
			if (this.multipleSelection.length <= 0) {
				this.$message.error('请至少选择一个课题!')
				return;
			}
			let tip;
			switch(type){
				case 0:
					tip = '“不予结题”后该课题不能再修改了，确定要继续吗？'
					break;
				case 1:
					tip = '确定要将所选的课题操作为“已结题”吗？'
					break;
				case 2:
					tip = '确定要将所选的课题操作为“退回修改”吗？'
					break;
				default:
					break;
			}
			this.$confirm(tip, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				
				this.queryUpdate = {
					quasiConcludingAuditParamList:[],
					type
				}
				if (type == 0) {
					this.queryUpdate.quasiConcludingAuditParamList = this.multipleSelection.map(item => {
						return {
							id:item.id,
							projectManagementId:item.projectManagementId,
							results:getReviewResultFunction(item.internResults, item.reviewResults, item.finalResults),
						}
					});
				}else{
					this.queryUpdate.quasiConcludingAuditParamList = this.multipleSelection.map(item => {
						return {
							id:item.id,
							projectManagementId:item.projectManagementId,
						}
					});
				}
				this.concludingFunction();
			});
			
			// quasiConcludingAuditParamList	拟立项id和评审结果集合
			// 	id	拟立项id
			// 	projectManagementId	课题管理id
			// 	results	审核状态
			// type	结题状态(0:不予结题,1:批准结题,2:退回修改)
			
			// 批准结题时,根据初评复评终评结果得出结论
			function getReviewResultFunction(internResults, reviewResults, finalResults){
				if (internResults==null&&reviewResults==null&&finalResults==null) {
					return null
				}
				if (internResults == reviewResults) {
					return internResults
				}else if (internResults == finalResults) {
					return internResults
				}else if (reviewResults == finalResults) {
					return reviewResults
				}else{
					return null
				}
			}
		},
		//批准结题、不予结题、退回修改操作
		concludingFunction() {
			concludingFunction(this.queryUpdate).then(res => {
				if (res.code == 200) {
					this.$message.success('操作成功');
					this.getData();
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 导出表格
		exportExcel() {
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '拟结题.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		// 分页导航
		handlePageChange(val) {
			this.query.pageNumber = val;
			this.getData();
		},
		handleSizeChange(val) {
			this.query.pageSize = val;
			this.getData(true);
		},
		// 获取评审结果数据
		async getReviewResult(){
			const res = await getPlatformInformationData(10)
			if (res.code == 200) {
				console.log('评审结果信息',res);
				this.reviewResultOptions = res.data
			}else{
				this.$message.error(res.data)
			}
		},
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100% !important;
}
.card-body {
	padding: 1.5rem 0;
}
.mb-2,
.mt-2 {
	padding: 0 1.5rem;
}
.file_box {
	position: relative;
	display: flex;
	align-items: center;
	border: 1px dashed #d9d9d9;
	height: 30px;
	padding: 0 20px;
	cursor: pointer;
	max-width: calc(100% - 150px);
	margin: 5px 0;
}
.file_box p {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 450px;
	margin-bottom: 0;
	line-height: normal;
}
.close_btn {
	position: absolute;
	top: -8px;
	right: -8px;
}
.wrap {
	background: #fafbfe;
	padding: 30px;
}
.con {
	min-height: 500px;
	background: #fff;
	padding: 30px;
	border-radius: 5px;
}
</style>
